import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronUp,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { IAddSingleBio } from "src/types/GlobalInterfaces";
import SingleBioMarkerResult from "./GlobalComponents/HealthProfiles/SingleBioMarkerResult";
import StartFav from "src/assets/images/website-images/start-fav.png";
import StartUnFav from "src/assets/images/website-images/start-unfav.png";
import moment from "moment";

interface IProps {
  item: IAddSingleBio;
  dob: string;
  gender: string;
  uid: string;
  onSuccess?: (id: string) => void;
  onClose?: () => void;
  favApiCall?: (id: string) => void;
  isMyProfile?: boolean;
  index?: number;
  isCustomer?: boolean;
}

const PendingBiomarkerComponent: React.FC<IProps> = ({
  item,
  dob = "",
  gender = "",
  uid = "",
  onSuccess = () => {},
  onClose = () => {},
  favApiCall = () => {},
  isMyProfile = true,
  index = 0,
  isCustomer = true,
}) => {
  const [selectedId, setSelectedId] = useState<string>("");
  return (
    <div>
      <div className="biomarker-new-ui biomarker-grid-pending-2">
        {/* <button disabled={!isMyProfile} onClick={() => favApiCall(item?._id)} className="flex items-center justify-center">
          <img
            src={item?.isFavourite ? StartFav : StartUnFav}
            alt="start"
            className="w-[17px] h-[17px]"
          />
        </button> */}
        <div className="font-size-18px text-white font-Poppins-Regular truncate w-full block">
          {item?.name || ""}
        </div>
        <div className="flex justify-center">
          <span className="new-biomarker-btn w-[98%] 2xl:py-1.5 py-1 whitespace-nowrap mx-auto text-center font-size-16px font-Poppins-Regular text-white">
            {item?.measurement || "-"}
            {/* {item?.isShown ? item?.measurement : "-"} */}
          </span>
        </div>
        
        {item?.date && (
          <div className="flex justify-center">
            <p className="font-size-15px text-white font-Poppins-Regular">
              {moment(item?.date).format("DD MMM YYYY")}
            </p>
          </div>
        )}

        <div className="flex justify-center">
          <FontAwesomeIcon
            onClick={() => setSelectedId(selectedId ? "" : item?._id)}
            className="cursor-pointer text-white"
            icon={selectedId === item?._id ? faChevronUp : faChevronDown}
            size="xs"
            id={`biomarker-show-hide-btn-${item?.name}`}
          />
        </div>
      </div>
      {selectedId === item?._id && (
        <div className={`new-health-vitals-dropdown`}>
          <SingleBioMarkerResult
            item={item}
            onSuccess={() => onSuccess(item?._id)}
            _date={dob}
            _gender={gender}
            uid={uid}
            isCustomer={isCustomer}
            index={index + 6000}
            customId={`${item?.name}`}
            type="biomarker"
          />
        </div>
      )}
    </div>
  );
};

export default PendingBiomarkerComponent;
